@if (tenant$ | async; as tenant) {
  @if (tenant?.enabled_features?.localization) {
    <button
      [ngStyle]="{ position: 'absolute', right: '0' }"
      (click)="openLanguageManager()"
      class="u-marginRight-16 u-marginTop-8"
      mat-stroked-button
      matTooltip="Languages"
      i18n-matTooltip="@@global.languages"
    >
      <mat-icon [ngStyle]="{ verticalAlign: '0' }" class="md-18"
        >language</mat-icon
      >{{ localeDisplayName }}
    </button>
  }
}
<div
  *ngIf="isLoading"
  class="u-position-absolute"
  [ngStyle]="{ top: 0, left: 0, right: 0 }"
  [@fadeInEnter]
>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div
  [ngSwitch]="viewMode"
  [ngStyle]="{ overflowY: 'auto' }"
  class="bg-color-white"
>
  <app-user-onboarding-view-hubs
    *ngSwitchCase="USER_ONBOARDING_ROUTE_PATHS.hubs"
    class="u-display-block"
    (navigateToNextView)="navigateBasedOnGroup($event)"
    [tenant]="tenant$ | async"
  >
  </app-user-onboarding-view-hubs>
  <ng-container *ngSwitchCase="USER_ONBOARDING_ROUTE_PATHS.hubSegments">
    <ng-container *ngIf="group | async as group">
      <ng-container *ngIf="userState | async as user">
        <ng-container *ngIf="memberships?.length">
          <app-user-onboarding-hub-preferences-view
            class="u-display-block"
            [group]="group"
            [membership]="memberships | appGroupMembership: group._id"
            [preregistrationMembership]="
              preregistrationMemberships | appGroupMembership: group._id
            "
            [user]="user"
            [tenant]="tenant$ | async"
            [viewMode]="USER_ONBOARDING_ROUTE_PATHS.hubSegments"
            [numberOfSteps]="numberOfSteps"
            (navigateToNextView)="
              navigateToOnboardingView(
                USER_ONBOARDING_ROUTE_PATHS.hubInteractions,
                $event
              )
            "
          >
          </app-user-onboarding-hub-preferences-view>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="USER_ONBOARDING_ROUTE_PATHS.hubInterests">
    <ng-container *ngIf="group | async as group">
      <ng-container *ngIf="userState | async as user">
        <app-user-onboarding-hub-preferences-view
          class="u-display-block"
          [group]="group"
          [membership]="memberships | appGroupMembership: group._id"
          [preregistrationMembership]="
            preregistrationMemberships | appGroupMembership: group._id
          "
          [user]="user"
          [tenant]="tenant$ | async"
          [viewMode]="USER_ONBOARDING_ROUTE_PATHS.hubInterests"
          [numberOfSteps]="numberOfSteps"
          (navigateToNextView)="
            navigateToOnboardingView(
              USER_ONBOARDING_ROUTE_PATHS.hubGoals,
              $event
            )
          "
        >
        </app-user-onboarding-hub-preferences-view>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="USER_ONBOARDING_ROUTE_PATHS.hubGoals">
    <ng-container *ngIf="group | async as group">
      <ng-container *ngIf="userState | async as user">
        <ng-container
          *ngIf="
            group.features_enabled?.goals &&
            hasValidAccountGroupMembership(group, user)
          "
        >
          <app-user-onboarding-view-goal-setting
            [group]="group"
            [tenant]="tenant$ | async"
            [user]="user"
            (navigateToNextView)="
              navigateToOnboardingView(
                USER_ONBOARDING_ROUTE_PATHS.introGoals,
                $event
              )
            "
          ></app-user-onboarding-view-goal-setting>
        </ng-container>
        <ng-container
          *ngIf="
            !group.features_enabled?.goals ||
            !hasValidAccountGroupMembership(group, user)
          "
        >
          <app-user-onboarding-hub-preferences-view
            class="u-display-block"
            [group]="group"
            [membership]="memberships | appGroupMembership: group._id"
            [preregistrationMembership]="
              preregistrationMemberships | appGroupMembership: group._id
            "
            [user]="user"
            [tenant]="tenant$ | async"
            [viewMode]="USER_ONBOARDING_ROUTE_PATHS.hubGoals"
            [numberOfSteps]="numberOfSteps"
            (navigateToNextView)="
              navigateToOnboardingView(
                USER_ONBOARDING_ROUTE_PATHS.introGoals,
                $event
              )
            "
          >
          </app-user-onboarding-hub-preferences-view>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="USER_ONBOARDING_ROUTE_PATHS.hubInteractions">
    <ng-container *ngIf="group | async as group">
      <ng-container *ngIf="userState | async as user">
        <app-user-onboarding-hub-preferences-view
          class="u-display-block"
          [group]="group"
          [membership]="memberships | appGroupMembership: group._id"
          [preregistrationMembership]="
            preregistrationMemberships | appGroupMembership: group._id
          "
          [programMemberships]="programMemberships"
          [user]="user"
          [tenant]="tenant$ | async"
          [viewMode]="USER_ONBOARDING_ROUTE_PATHS.hubInteractions"
          [numberOfSteps]="numberOfSteps"
          (navigateToNextView)="
            navigateToOnboardingView(
              USER_ONBOARDING_ROUTE_PATHS.hubInterests,
              $event
            )
          "
        >
        </app-user-onboarding-hub-preferences-view>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="USER_ONBOARDING_ROUTE_PATHS.introGoals">
    <ng-container *ngIf="group | async as group">
      <ng-container *ngIf="userState | async as user">
        <ng-container *ngIf="tenant$ | async as tenant">
          <app-user-onboarding-view-intro-goals-selection
            class="u-display-block"
            [group]="group"
            [tenant]="tenant"
            [user]="user"
            (navigateToNextView)="
              navigateOnOnboardingFinish($event, tenant, user)
            "
          >
          </app-user-onboarding-view-intro-goals-selection>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
